import {
  GET_MEMBER_INFO_SUCCESS,
  UPDATE_MEMBER_INFO_SUCCESS,
  MEMBER_LOGIN_SUCCESS,
  MEMBER_LOGOUT,
} from '../actions/member'
import {REHYDRATE} from 'redux-persist'
import {setAccessToken} from '../../utilities/NetworkingAuth'
export default function user(state, action) {
  switch (action.type) {
    case MEMBER_LOGIN_SUCCESS:
      return {
        ...state,
        memberLoggedIn: true,
        memberInfo: action.payload,
      }
    case MEMBER_LOGOUT:
      return {
        ...state,
        memberLoggedIn: false,
        memberInfo: {},
      }
    case UPDATE_MEMBER_INFO_SUCCESS:
      return {
        ...state,
        memberInfo: action.payload,
      }
    case GET_MEMBER_INFO_SUCCESS:
      return {
        ...state,
        memberInfo: action.payload,
      }
    case REHYDRATE:
      if (!!action.payload?.member?.memberLoggedIn) {
        setAccessToken(action.payload?.member?.memberInfo?.token)
      }
      return {
        ...state,
        ...(action?.payload?.member || {}),
      }
    default:
      return {
        ...state,
      }
  }
}
